import script from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminDashboardView.vue?vue&type=style&index=0&id=7d00796c&scoped=true&lang=css"
import "./AdminDashboardView.vue?vue&type=style&index=1&id=7d00796c&scoped=true&lang=css"
import "./AdminDashboardView.vue?vue&type=style&index=2&id=7d00796c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d00796c"]])

export default __exports__